"use strict";
/*
 * Created on 19. 5. 2021
 *
 * Copyright (c) 2021 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converter for {@link DistributionException} (for REST API and database).
 *
 * @author Radek Beran
 */


var DistributionExceptionConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(DistributionExceptionConverter, _DataObjectConverter_);

  function DistributionExceptionConverter() {
    _classCallCheck(this, DistributionExceptionConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(DistributionExceptionConverter).apply(this, arguments));
  }

  return DistributionExceptionConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.DistributionExceptionConverter = DistributionExceptionConverter;